import styled from "styled-components";
import colors from "assets/styles/colors";
import breakpoints from "assets/styles/breakpoints";

interface ContainerProps {
    fileUploadActive?: boolean;
}

export default styled.div<ContainerProps>`
    .container {
        display: flex;
        flex-direction: column;
        position: relative;
        align-items: flex-start;
        @media only screen and (max-width: ${breakpoints.size.md}) {
            align-items: stretch;
        }

        .input-wrapper {
            width: 100%;

            .radio-group-wrapper {
                margin-top: 10px;
                margin-bottom: 20px;

                .radio-text-input-wrapper {
                    > * {
                        max-width: 300px;
                    }
                }

                .radio-group {
                    flex-direction: row;

                    & .MuiFormControlLabel-root {
                        margin: 0 15px 0 0;
                    }
                }

                .radio-option {
                    color: ${colors.textNavy};

                    &.Mui-checked {
                        color: ${colors.textNavy}
                    }
                }
            }
        }
    }

    .header {
        width: 100%;
        display: flex;
        justify-content: space-between;

        .title-container {
            width: 50%;

            .title {
                font-size: 30px;
                color: ${(props) => props.theme.pageTitleText};
                letter-spacing: 1.7px;
                margin: 20px 0 10px 0;
                font-weight: 400;
                display: flex;
                flex-direction: row;
                width: 90%;
            }

            .details {
                display: flex;
                flex-direction: row;

                .detail {
                    display: flex;
                    flex-direction: row;
                    align-items: center;

                    p {
                        color: ${(props) => props.theme.homeListRowText};
                        font-size: 14px;
                    }

                    svg {
                        color: ${(props) => props.theme.homeListRowText};
                        font-size: 10px;
                        margin-right: 4px;
                        margin-bottom: 2px;
                    }
                }
            }
        }

        .actions-container {
            width: 50%;
            display: flex;
            justify-content: flex-end;
            align-items: center;

            .button {

            }
        }
    }

    .selections {
        margin-top: 20px;
        display: flex;
        flex-direction: row;

        @media only screen and (max-width: ${breakpoints.size.md}) {
            flex-direction: column;
        }

        > * {
            min-width: 200px;
        }

        > :last-child {
            @media only screen and (max-width: ${breakpoints.size.md}) {
                margin-top: 10px;
                margin-left: 0;
            }
        }
        
        > :first-child {
            margin-right: 10px;
        }

        .disabled {
            opacity: 0.3;
            cursor: not-allowed;
        }
    }

    .loadingScreen {
        margin-top: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-grow: 1;
    }

    label {
        letter-spacing: 0.1em;
        color: ${colors.textNavy};
        margin-top: 10px;
        margin-bottom: 20px;
    }

    hr {
        width: calc(100% - 10px);
        outline: none;
        border: none;

        margin: 0 5px;

        border-bottom: 1px solid #efefef;
    }

    .form-wrapper {
        @media only screen and (min-width: ${breakpoints.size.lg}) {
            width: 100%;
        }
        display: flex;
        flex-direction: column;
        opacity: 1;
        transition: opacity 0.3s;
        pointer-events: Default;

        .file-upload-wrapper {
            max-width: 800px;
            margin-top: 20px;
            ${(props) =>
                    !props.fileUploadActive &&
                    `
                    opacity: 0.3;
                    pointer-events: None;
                `}
        }

        .save-button {
            margin: 0;
        }
    }

    .file-upload-warning {
        opacity: 1;
        transition: opacity 0.3s;
        margin-left: 10px;
        margin-top: 10px;
        ${(props) =>
                props.fileUploadActive &&
                `
            opacity: 0;
            `}
    }

    .agenda-item-topic {
        width: 50%;
    }

    .files {
        display: flex;
        flex-wrap: wrap;
        margin-top: 20px;

        .upload-files-label {
            width: 100%;
            margin-bottom: 10px;
        }

        .file-wrapper {
            position: relative;
        }

        .delete {
            cursor: pointer;
            border: 0;
            position: absolute;
            background-color: transparent;
            bottom: 0;
            right: 10px;
            transition: scale 0.3s ease;

            :hover {
                color: ${(props) => props.theme.accentButtonBackground};
                scale: 1.3;
            }
        }
    }

    .modal {
        padding: 20px;
        display: flex;
        flex-direction: column;
        text-align: center;

        .move-meeting-select {
            margin: 20px 0;
            min-width: 300px;
            text-align: left;
        }

        .button-container {
            margin-top: 10px;
            display: flex;
            justify-content: center;
        }
    }
`;
